module.exports = __webpack_public_path__ + "img/ico5.b630cc13.png";